<mat-drawer-container>
  <mat-drawer class="w-auto" mode="side" [opened]="sideBarOpen">
    <app-sidenav (toggleSideNav)="onToggleSideNav($event)"></app-sidenav>
  </mat-drawer>
  <mat-drawer-content
    class="dashboard-body"
    [ngClass]="collapsed ? 'dashboard-body-collapsed' : ''">
    <app-header></app-header>
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
